import { module } from 'angular';
import component from './kdatepicker.component';

export default module('app.kdatepicker', [])
	.component('kdatepicker', component)
	.name;
